import { InviteUserToMeetingComponent } from "./invite-user-to-meeting.component";
export var InviteUserToMeetingModule = angular
    .module('inviteUserToMeeting', [])
    .component(InviteUserToMeetingComponent.selector, InviteUserToMeetingComponent.component)
    .name;
//# sourceMappingURL=invite-user-to-meeting.module.js.map